export const name = "Self-reflection Edition"
export const menu = "Self-reflection"
export const edition = "Self-reflection Edition"
export const suggestedPlayer = "1 player"
export const color = {
    primary: {
        main:  '#c10016',
        contrastText: '#ffffff',
    },
    secondary: {
        main:  '#c10016',
    }
}
export const levels = ["Self-reflection"]
export const isExpansion = false

export const backDesc = [
    "Self awareness starts\n with self-reflection"
]

export const level1 = [ // 52 cards
    "When do I feel most\n helpful to others?",
    "What do I keep doing\n that keeps hurting? Why\n do I keep repeating this\n behavior?",
    "What did the people who raised\n me teach me about love? What\n lessons do I want to keep? What\n do I want to challenge?",
    "Are any of my\n insecurities hurting\n anyone else by\n accident?",
    "How would I describe my\n relationship with myself\n in one word?",
    "What do I need help\n with currently? Who\n can help me? How can I\n help myself?",
    "What am I putting off\n that feels important?\n Why am I avoiding it?",
    "When have I given too much of\n myself in a relationship? What\n did that look like? What lesson\n did that leave me with?",
    "What's the most exciting\n improvement I've been seeing\n in myself recently?",
    "What is an unpopular opinion\n of mine that I hesitate to\n share with others?",
    "When was the last time I\n remember being mean to\n someone? Why did I act\n this way?",
    "I want to thank\n myself for _________.",
    "Which one of my mistakes\n taught me the most this\n past year? What did it\n teach me?",
    "What purchase has meant\n the most to me recently?\n What is a purchase that I\n could have done without?",
    "What have I accomplished\n recently that would have\n shocked me a year ago?",
    "What's the best gift I can\n give myself in this chapter\n of my life?",
    "What expectation have\n I set on someone that has\n been hurting me the most?",
    "What's an important\n boundary I want to set\n with someone in my life?\n Why haven't I set it\n already?",
    "What's one small step I can\n take today towards a goal\n that feels out of reach?",
    "What's a\n non-negotiable\n in my life?",
    "What have I tolerated\n from people in the past\n that I no longer have\n space for?",
    "What have I outgrown\n recently? What am I\n growing into?",
    "What can I be kinder\n towards myself for\n today?",
    "What have I always\n accepted as true that\n turned out to be false?",
    "What or who\n do I have an unhealthy\n relationship with?",
    "In what ways do I want to\n be like the people that raised\n me? What's important for me\n to avoid repeating?",
    "What's become more\n important to me recently\n than ever before?",
    "When was the last\n time I truly enjoyed my\n own company? What\n was I doing?",
    "What is the most fun I\n can remember having\n recently? What was I\n doing? Who was I with?",
    "What's something mean\n that was said to me in my\n childhood that I carry to\n this day? What would I say\n to my younger self now?",
    "Whose life seems most\n fulfilling to me? What does\n their life look like?",
    "What insecurity has\n been holding me back\n the most?",
    "What do I dislike that most\n people love? What do I love\n that most people dislike?",
    "When do I feel most\n productive? What time is it\n usually? Am I alone or with\n others? (Get specific.)",
    "Who intimidates\n me? Why do they\n intimidate me?",
    "What do I have to offer in\n a romantic relationship?\n What do I want to receive?",
    "What have I been\n sensitive to lately?",
    "Who do I envy? Why\n do I envy them?",
    "Who do I feel most\n myself around? Why?",
    "What am I wearing when I\n have the best time? What\n do I always regret\n wearing?",
    "What have my past\n relationships taught\n m about myself?\n Good and bad?",
    "What's my most toxic\n trait I can admit to?\n Where do I think it\n stems from?",

    "Wild Card What's my favorite song at\n the moment? Why do I love it\n so much? (Play it for\n yourself.)",
    "Wild Card What am I doubting about\n myself currently? (Replace that\n thought with an affirmation and\n repeat it out loud.)",
    "Wild Card What is one truth I've\n recently come to terms\n with? (Write it out.)",
    "Wild Card Look in the mirror today\n and give yourself a\n genuine compliment.",
    "Wild Card What do I need to get\n off my chest? (Write it out.)",
    "Wild Card What is my happiness level on a\n scale of 1-10? (Write it down and\n date it. Why is it this number?\n What would make it 1\n score higher?)",
    "Wild Card What feels impossible today that\n would shock me to accomplish in\n a year? (Write it down and date it.)",
    "Wild Card Take 3 deep breaths\n before answering the\n next question.",
    "Wild Card What do I need to hear\n most right now? (Write it\n out. Place somewhere\n you'll see often.)",
    "Wild Card What are 3 things I love\n most about myself today?\n (Write them out.)"
]